<template>
    <div class="dashboard-modal-filtering">
        <div class="modal-header">
            <h2 v-if="isKpi" id="modal-heading">Vælg filtrering</h2>
            <h2 v-else id="modal-heading">Gemte filtreringer</h2>
        </div>

        <div class="modal-content">
            <table aria-labelledby="modal-heading">
                <thead>
                    <tr>
                        <th></th>
                        <th width="360" scope="col" role="columnheader">Navn</th>
                        <th scope="col" role="columnheader">Filtre</th>
                        <th width="220"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="filteringListLoading">
                        <td colspan="3" class="table__loader">
                            <base-table-loader>Indlæser gemte filtreringer...</base-table-loader>
                        </td>
                    </tr>
                    <tr v-else-if="filteringListSorted.length === 0">
                        <td colspan="3"><em>Der er ikke gemt nogle filtreringer endnu...</em></td>
                    </tr>
                    <template v-for="item in filteringListSorted">
                        <tr :class="{ 'editing': editing === item.id }" :key="item.id">
                            <td>
                                <icon class="small-svg fill-dark-gray" :name="item.type === 'request' ? 'enquiry' : item.type" />
                            </td>
                            <td>
                                <template v-if="editing === item.id">
                                    <input type="text" v-model="item.name" />
                                    <button type="submit" class="button-green" @click="filteringSave(item)">Gem</button>
                                    <button type="button" class="button-naked" @click="editing = null">Fortryd</button>
                                </template>
                                <div class="truncate" style="max-width: 36ch; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" v-else :title="item.description">{{ item.name }}</div></td>
                            <td>
                                <!-- <div class="truncate" style="max-width: 36ch; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" :title="item.filter.join(', ')">{{ item.filter.join(', ') }}</div> -->

                                <div class="list-filter-group">
                                    <!-- GENEREL -->
                                    <template v-if="supplyTypes && supplyTypes.length > 1">
                                        <div class="list-filter-item" v-for="supplyType in supplyTypes" :key="supplyType.sysBusinessAreaTypeId" v-if="item.parameterList.WhereBusinessAreaTypeIdList.includes(supplyType.sysBusinessAreaTypeId)" :class="'list-filter-item--' + supplyType.systemName">
                                            <span class="list-filter-item-label">Forretningsområde:</span><span class="list-filter-item-value"><icon class="tiny-svg" :name="supplyType.systemName" />{{ supplyType.description }}</span>
                                        </div>
                                    </template>

                                    <div class="list-filter-item" v-if="item.parameterList.WhereLikeOccurrenceAddress || item.parameterList.WhereLikeAddress">
                                        <span class="list-filter-item-label">Adresse:</span><span class="list-filter-item-value">{{ item.parameterList.WhereLikeOccurrenceAddress || item.parameterList.WhereLikeAddress }}</span>
                                    </div>

                                    <!-- ENQUIRIES -->
                                    <template v-if="item.type === 'request'">
                                        <div class="list-filter-item" v-if="item.parameterList.WhereIsClosed">
                                            <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis også afsluttede</span>
                                        </div>

                                        <div class="list-filter-item" v-for="responsible in item.parameterList.WhereOwnerUserIdList" :key="responsible">
                                            <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="problemType in item.parameterList.WhereProblemTypeIdList" :key="problemType">
                                            <span class="list-filter-item-label">Problemtype:</span><span class="list-filter-item-value">{{ problemTypesList.find(item => item.id === problemType).area }}, {{ problemTypesList.find(item => item.id === problemType).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="contactType in item.parameterList.WhereClientTypeIdList" :key="contactType">
                                            <span class="list-filter-item-label">Kontakttype:</span><span class="list-filter-item-value">{{ contactTypesList.find(item => item.id === contactType).area }}, {{ contactTypesList.find(item => item.id === contactType).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereFromDate || item.parameterList.WhereToDate">
                                            <span class="list-filter-item-label">Problemdato<template v-if="item.parameterList.WhereFromDate && !item.parameterList.WhereToDate"> efter</template><template v-if="!item.parameterList.WhereFromDate && item.parameterList.WhereToDate"> før</template>:</span>
                                            <span class="list-filter-item-value">
                                                <template v-if="item.parameterList.WhereFromDate && item.parameterList.WhereToDate">
                                                    {{ item.parameterList.WhereFromDate | formatDateShort }} - {{ item.parameterList.WhereToDate | formatDateShort }}
                                                </template>
                                                <template v-if="item.parameterList.WhereFromDate && !item.parameterList.WhereToDate">
                                                    {{ item.parameterList.WhereFromDate | formatDateShort }}
                                                </template>
                                                <template v-if="!item.parameterList.WhereFromDate && item.parameterList.WhereToDate">
                                                    {{ item.parameterList.WhereToDate | formatDateShort }}
                                                </template>
                                            </span>
                                        </div>
                                    </template>

                                    <!-- TASKS -->
                                    <template v-if="item.type === 'task'">
                                        <div class="list-filter-item" v-if="item.parameterList.WhereIsClosed">
                                            <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis også afsluttede</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereReadyForApproval">
                                            <!-- SKAL TESTES -->
                                            <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis kun færdigmeldte</span>
                                        </div>

                                        <div class="list-filter-item" v-for="responsible in item.parameterList.WhereOwnerUserIdList" :key="responsible">
                                            <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="company in item.parameterList.WhereSentToOrganizationIdList" :key="company">
                                            <span class="list-filter-item-label">Virksomhed:</span><span class="list-filter-item-value">{{ firms.find(item => item.id === company).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="contact in item.parameterList.WhereSentToUserIdList" v-if="users.find(item => item.userId === contact)" :key="contact">
                                            <span class="list-filter-item-label">Medarbejder:</span><span class="list-filter-item-value">{{ users.find(item => item.userId === contact).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereLikeTaskName">
                                            <span class="list-filter-item-label">Opgavenavn:</span><span class="list-filter-item-value">{{ item.parameterList.WhereLikeTaskName }}</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereAfterStartDate || item.parameterList.WhereBeforeLatestDate">
                                            <span class="list-filter-item-label">Oprettet<template v-if="item.parameterList.WhereAfterStartDate && !item.parameterList.WhereBeforeLatestDate"> efter</template><template v-if="!item.parameterList.WhereAfterStartDate && item.parameterList.WhereBeforeLatestDate"> før</template>:</span>
                                            <span class="list-filter-item-value">
                                                <template v-if="item.parameterList.WhereAfterStartDate && item.parameterList.WhereBeforeLatestDate">
                                                    {{ item.parameterList.WhereAfterStartDate | formatDateShort }} - {{ item.parameterList.WhereBeforeLatestDate | formatDateShort }}
                                                </template>
                                                <template v-if="item.parameterList.WhereAfterStartDate && !item.parameterList.WhereBeforeLatestDate">
                                                    {{ item.parameterList.WhereAfterStartDate | formatDateShort }}
                                                </template>
                                                <template v-if="!item.parameterList.WhereAfterStartDate && item.parameterList.WhereBeforeLatestDate">
                                                    {{ item.parameterList.WhereBeforeLatestDate | formatDateShort }}
                                                </template>
                                            </span>
                                        </div>
                                    </template>

                                    <!-- REQUISITIONS -->
                                    <template v-if="item.type === 'requisition'">
                                        <div class="list-filter-item" v-if="item.parameterList.WhereReportIsApproved">
                                            <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis kun godkendte</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereOverdue">
                                            <!-- SKAL TESTES -->
                                            <span class="list-filter-item-label">Tidsfrist:</span><span class="list-filter-item-value">Overskredet</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereSerialNumber">
                                            <span class="list-filter-item-label">Løbenummer:</span><span class="list-filter-item-value">{{ item.parameterList.WhereSerialNumber }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="responsible in item.parameterList.WhereOwnerUserIdList" :key="responsible">
                                            <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="company in item.parameterList.WhereSentToOrganizationIdList" :key="company">
                                            <span class="list-filter-item-label">Virksomhed:</span><span class="list-filter-item-value">{{ firms.find(item => item.id === company).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="contact in item.parameterList.WhereSentToUserIdList" v-if="users.find(item => item.userId === contact)" :key="contact">
                                            <span class="list-filter-item-label">Medarbejder:</span><span class="list-filter-item-value">{{ users.find(item => item.userId === contact).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="activityType in item.parameterList.WhereActivityTypeIdList" :key="activityType">
                                            <span class="list-filter-item-label">Aktivitetstype:</span><span class="list-filter-item-value">{{ activityTypesList.find(item => item.id === activityType).area }}, {{ activityTypesList.find(item => item.id === activityType).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="statusType in item.parameterList.WhereRequisitionAndReportStatusList" :key="statusType">
                                            <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">{{ statusTypes.find(item => item.systemName === statusType).description }}</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereLikeTaskName">
                                            <span class="list-filter-item-label">Opgavenavn:</span><span class="list-filter-item-value">{{ item.parameterList.WhereLikeTaskName }}</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereAfterStartDate || item.parameterList.WhereBeforeLatestDate">
                                            <span class="list-filter-item-label">Oprettet<template v-if="item.parameterList.WhereAfterStartDate && !item.parameterList.WhereBeforeLatestDate"> efter</template><template v-if="!item.parameterList.WhereAfterStartDate && item.parameterList.WhereBeforeLatestDate"> før</template>:</span>
                                            <span class="list-filter-item-value">
                                                <template v-if="item.parameterList.WhereAfterStartDate && item.parameterList.WhereBeforeLatestDate">
                                                    {{ item.parameterList.WhereAfterStartDate | formatDateShort }} - {{ item.parameterList.WhereBeforeLatestDate | formatDateShort }}
                                                </template>
                                                <template v-if="item.parameterList.WhereAfterStartDate && !item.parameterList.WhereBeforeLatestDate">
                                                    {{ item.parameterList.WhereAfterStartDate | formatDateShort }}
                                                </template>
                                                <template v-if="!item.parameterList.WhereAfterStartDate && item.parameterList.WhereBeforeLatestDate">
                                                    {{ item.parameterList.WhereBeforeLatestDate | formatDateShort }}
                                                </template>
                                            </span>
                                        </div>
                                    </template>

                                    <!-- ROUTINES -->
                                    <template v-if="item.type === 'routine'">
                                        <div class="list-filter-item" v-if="item.parameterList.WhereIsClosed">
                                            <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis også afsluttede</span>
                                        </div>

                                        <div class="list-filter-item" v-for="responsible in item.parameterList.WhereOwnerUserIdList" :key="responsible">
                                            <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-for="company in item.parameterList.WhereSentToUserIdList" :key="company">
                                            <span class="list-filter-item-label">Virksomhed:</span><span class="list-filter-item-value">{{ firms.find(item => item.id === company).name }}</span>
                                        </div>

                                        <div class="list-filter-item" v-if="item.parameterList.WhereLikeTaskName">
                                            <span class="list-filter-item-label">Rutinenavn:</span><span class="list-filter-item-value">{{ item.parameterList.WhereLikeTaskName }}</span>
                                        </div>
                                    </template>
                                </div>
                            </td>
                            <td v-if="isKpi" align="center">
                                <button type="button" class="button-green" @click="addFilterToKpi(item.id)">Vælg</button>
                            </td>
                            <td v-else align="center">
                                <button type="button" class="button-blue" @click="filteringEdit(item.id)">Rediger</button>
                                <button type="button" class="button-green" @click="filteringActivate(item.id)">Aktiver</button>
                                <button type="button" class="button-red" @click="filteringDelete(item.id)">Slet</button>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-naked" @click="closeModal()">{{ isKpi ? 'Annuller' : 'Luk' }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from '@/store/api.js'

export default {
    name: 'dashboard-modal-filters',
    props: [
        'data'
    ],
    data () {
        return {
            filteringList: [],
            filteringListLoading: false,
            sortKey: 'name',
            sortDirection: 'ASC',
            editing: null
        }
    },
    computed: {
        ...mapGetters({
            supplyTypes: 'getBusinessAreaTypes',
            caseworkers: 'caseWorkerList',
            problemTypes: 'getProblemTypes',
            contactTypes: 'getCClientTypeList',
            firms: 'getAllFirmsForActivity',
            users: 'getAllUsersInFirmForActivity',
            activityTypes: 'getCActivityTypeList',
            statusTypes: 'getSysRequisitionAndReportStatusList',

            getFilters: 'getFilters'
        }),

        isKpi () {
            return this.data && this.data.isKpi
        },
        contactTypesList () {
            const contactTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.contactTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((contactType) => {
                    contactTypeList.push({
                        id: contactType.typeId,
                        name: contactType.description,
                        area: supplyType.description
                    })
                })
            })

            return contactTypeList
        },
        problemTypesList () {
            const problemTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.problemTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((problemType) => {
                    problemTypeList.push({
                        id: problemType.typeId,
                        name: problemType.description,
                        area: supplyType.description
                    })
                })
            })

            return problemTypeList
        },
        activityTypesList () {
            const activityTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.activityTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((activityType) => {
                    activityTypeList.push({
                        id: activityType.typeId,
                        name: activityType.description,
                        area: supplyType.description
                    })
                })
            })

            return activityTypeList
        },

        filteringListSorted () {
            return [...this.filteringList].sort((a, b) => {
                let modifier = 1

                if (this.sortDirection === 'DESC') {
                    modifier = -1
                }

                if (a[this.sortKey] < b[this.sortKey]) {
                    return -1 * modifier
                }
                if (a[this.sortKey] > b[this.sortKey]) {
                    return 1 * modifier
                }

                return 0
            })
        }
    },
    methods: {
        ...mapActions({
            saveQueryRequestFiltering: 'saveQueryRequestFiltering',
            saveQueryTaskFiltering: 'saveQueryTaskFiltering',
            saveQueryRequisitionFiltering: 'saveQueryRequisitionFiltering',
            saveQueryRoutineFiltering: 'saveQueryRoutineFiltering',
            setSelectedTab: 'setSelectedTab',
            setFilters: 'setFilters',
            resetFilters: 'resetFilters',
            setKPI: 'setKPI'
        }),
        filteringEdit (id) {
            this.editing = id
        },
        filteringSave (item) {
            const requestQuery = {
                saveFilter: true,
                filterId: item.id,
                filterName: item.name
            }

            if (item.type === 'request') {
                this.saveQueryRequestFiltering(requestQuery)
                    .then(() => {
                        this.editing = false
                    })
                    .catch((error) => {
                        console.error('ERROR: ', error)
                    })
            } else if (item.type === 'task') {
                this.saveQueryTaskFiltering(requestQuery)
                    .then(() => {
                        this.editing = false
                    })
                    .catch((error) => {
                        console.error('ERROR: ', error)
                    })
            } else if (item.type === 'requisition') {
                this.saveQueryRequisitionFiltering(requestQuery)
                    .then(() => {
                        this.editing = false
                    })
                    .catch((error) => {
                        console.error('ERROR: ', error)
                    })
            } else if (item.type === 'routine') {
                this.saveQueryRoutineFiltering(requestQuery)
                    .then(() => {
                        this.editing = false
                    })
                    .catch((error) => {
                        console.error('ERROR: ', error)
                    })
            }
        },
        filteringActivate (id) {
            axios.get('/Query/GetFilters', { filterId: id })
                .then((response) => {
                    if (response.data.length > 0) {
                        const filtering = response.data[0]
                        const filteringParameters = JSON.parse(filtering.parametersJson)

                        this.resetFilters('root')
                        this.setSelectedTab(`${filtering.filterType}s`)
                        // Supply type
                        if (filteringParameters.WhereBusinessAreaTypeIdList) {
                            this.getFilters.supplyType = filteringParameters.WhereBusinessAreaTypeIdList
                        }
                        // Address
                        if (filteringParameters.WhereLikeOccurrenceAddress) {
                            this.getFilters.address = filteringParameters.WhereLikeOccurrenceAddress
                        } else if (filteringParameters.WhereLikeAddress) {
                            this.getFilters.address = filteringParameters.WhereLikeAddress
                        }
                        if (filtering.filterType === 'request') {
                            // Closed
                            if (filteringParameters.WhereIsClosed) {
                                this.getFilters.enquiries.showClosed = filteringParameters.WhereIsClosed
                            }
                            // Responsible
                            if (filteringParameters.WhereOwnerUserIdList) {
                                this.getFilters.enquiries.responsible = filteringParameters.WhereOwnerUserIdList
                            }
                            // From date
                            if (filteringParameters.WhereFromDate) {
                                this.getFilters.enquiries.createdDate.from = new Date(filteringParameters.WhereFromDate)
                            }
                            // To date
                            if (filteringParameters.WhereToDate) {
                                this.getFilters.enquiries.createdDate.to = new Date(filteringParameters.WhereToDate)
                            }
                            // Problem type
                            if (filteringParameters.WhereProblemTypeIdList) {
                                this.getFilters.enquiries.problemType = filteringParameters.WhereProblemTypeIdList
                            }
                            // Client type
                            if (filteringParameters.WhereClientTypeIdList) {
                                this.getFilters.enquiries.contactType = filteringParameters.WhereClientTypeIdList
                            }
                        } else if (filtering.filterType === 'task') {
                            // Name
                            if (filteringParameters.WhereLikeTaskName) {
                                this.getFilters.tasks.name = filteringParameters.WhereLikeTaskName
                            }
                            // Responsible
                            if (filteringParameters.WhereOwnerUserIdList) {
                                this.getFilters.tasks.responsible = filteringParameters.WhereOwnerUserIdList
                            }
                            // Closed
                            if (filteringParameters.WhereIsClosed) {
                                this.getFilters.tasks.showClosed = filteringParameters.WhereIsClosed
                            }
                            // Sent to user
                            if (filteringParameters.WhereSentToUserIdList) {
                                this.getFilters.tasks.contact = filteringParameters.WhereSentToUserIdList
                            }
                            // Sent to organization
                            if (filteringParameters.WhereSentToOrganizationIdList) {
                                this.getFilters.tasks.company = filteringParameters.WhereSentToOrganizationIdList
                            }
                            // Start date
                            if (filteringParameters.WhereAfterStartDate) {
                                this.getFilters.tasks.startDate.from = new Date(filteringParameters.WhereAfterStartDate)
                            }
                            // End date
                            if (filteringParameters.WhereBeforeLatestDate) {
                                this.getFilters.tasks.startDate.to = new Date(filteringParameters.WhereBeforeLatestDate)
                            }
                            // Ready for approval
                            if (filteringParameters.WhereReadyForApproval) {
                                this.getFilters.tasks.showReadyForApproval = filteringParameters.WhereReadyForApproval
                            }
                        } else if (filtering.filterType === 'requisition') {
                            // Task name
                            if (filteringParameters.WhereLikeTaskName) {
                                this.getFilters.requisitions.name = filteringParameters.WhereLikeTaskName
                            }
                            // Responsible
                            if (filteringParameters.WhereOwnerUserIdList) {
                                this.getFilters.requisitions.responsible = filteringParameters.WhereOwnerUserIdList
                            }
                            // Sent to user
                            if (filteringParameters.WhereSentToUserIdList) {
                                this.getFilters.requisitions.contact = filteringParameters.WhereSentToUserIdList
                            }
                            // Sent to organization
                            if (filteringParameters.WhereSentToOrganizationIdList) {
                                this.getFilters.requisitions.company = filteringParameters.WhereSentToOrganizationIdList
                            }
                            // Activity type
                            if (filteringParameters.WhereActivityTypeIdList) {
                                this.getFilters.requisitions.activityType = filteringParameters.WhereActivityTypeIdList
                            }
                            // Start date
                            if (filteringParameters.WhereAfterStartDate) {
                                this.getFilters.requisitions.startDate.from = new Date(filteringParameters.WhereAfterStartDate)
                            }
                            // End date
                            if (filteringParameters.WhereBeforeLatestDate) {
                                this.getFilters.requisitions.startDate.to = new Date(filteringParameters.WhereBeforeLatestDate)
                            }
                            // Overdue
                            if (filteringParameters.WhereOverdue) {
                                this.getFilters.requisitions.dateOverdue = filteringParameters.WhereOverdue
                            }
                            // Status
                            if (filteringParameters.WhereRequisitionAndReportStatusList) {
                                this.getFilters.requisitions.statusType = filteringParameters.WhereRequisitionAndReportStatusList
                            }
                            // Approved
                            if (filteringParameters.WhereReportIsApproved) {
                                this.getFilters.requisitions.showApproved = filteringParameters.WhereReportIsApproved
                            }
                            // Serial number
                            if (filteringParameters.WhereSerialNumber) {
                                this.getFilters.requisitions.serialNumber = filteringParameters.WhereSerialNumber
                            }
                        } else if (filtering.filterType === 'routine') {
                            // Name
                            if (filteringParameters.WhereLikeTaskName) {
                                this.getFilters.routines.name = filteringParameters.WhereLikeTaskName
                            }
                            // Responsible
                            if (filteringParameters.WhereOwnerUserIdList) {
                                this.getFilters.routines.responsible = filteringParameters.WhereOwnerUserIdList
                            }
                            // Closed
                            if (filteringParameters.WhereIsClosed) {
                                this.getFilters.routines.showClosed = filteringParameters.WhereIsClosed
                            }
                            // Sent to organization
                            if (filteringParameters.WhereSentToUserIdList) {
                                this.getFilters.routines.company = filteringParameters.WhereSentToUserIdList
                            }
                        }
                        this.closeModal()
                    }
                })
                .catch((error) => {
                    console.error('error', error)
                })
        },
        addFilterToKpi (id) {
            axios.post('/Query/addFilterToKpi', { filterId: id })
                .then((_) => {
                    this.setKPI()
                    this.closeModal()
                })
                .catch((error) => {
                    console.error('error', error)
                })
        },
        filteringDelete (id) {
            axios.post('/Query/DeleteFilter', { filterId: id })
                .then(() => {
                    this.filteringList = this.filteringList.filter(filtering => filtering.id !== id)
                })
                .catch((error) => {
                    console.error('error', error)
                })
        },
        closeModal () {
            this.$emit('close')
        }
    },
    mounted () {
        axios.get('/Query/GetFilters')
            .then((response) => {
                this.filteringList = response.data
                    .map((filtering) => {
                        return {
                            id: filtering.filterId,
                            type: filtering.filterType,
                            name: filtering.name,
                            parameterList: JSON.parse(filtering.parametersJson)
                        }
                    })
                    .filter((filtering) =>
                        !this.data.filteringType || filtering.type === this.data.filteringType
                    )
            })
            .catch((error) => {
                console.error('error', error)
            })
    }
}
</script>

<style lang="scss">
.dashboard-modal-filtering {

    .modal-content {
        max-height: calc(100vh - 48px - (1.4rem * 1.4) - 8px - 36px - 36px - 48px);
        overflow: auto;
    }
    table {
        border: none;
    }
    thead {
        background: none;
        border: none;
        position: sticky;
        top: 0;
        z-index: 2;

        &::before {
            background: #ebebec;
            border-bottom: 2px solid #d6d6d8;
            border-radius: 6px 6px 0 0;
            content: '';
            height: 100%;
            position: absolute;
            width: 100%;
            z-index: -1;
        }

        th {
            font-weight: 500;
            padding: 12px 6px;

            &:first-child {
                padding-left: 12px;
            }
            &:last-child {
                padding-right: 12px;
            }
        }
    }
    tbody {
        background: none;
        border: none;
        border-bottom: 2px solid #d6d6d8;

        tr {

            &:nth-child(even) {
                background: none;
            }

            &.editing {
                background: #f5f5f5;

                input:not([type=checkbox]):not([type=radio]) {
                    margin-bottom: 6px;
                }
            }
        }
        td {
            border-bottom: 1px solid #d6d6d8;
            color: #5c5c5c;
            padding: 12px 6px;
            vertical-align: text-top;

            &:first-child {
                padding-left: 12px;
            }
            &:last-child {
                padding-right: 12px;
            }
        }
    }

    button {
        min-width: auto;
        padding-left: 12px;
        padding-right: 12px;
    }
    .button-icon {
        margin-left: 10px;
        cursor: pointer;
        border: 2px solid transparent;
        border-radius: 5px;
        width: 40px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        svg {
            height: 30px;
            width: 30px;
        }

        &:hover {
            border-color: white;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/dashboard-modal-filter-list.vue